import { ACTION_BY } from '../../../../common/constant/constant';
import type { SelectAnnotationPayloadT } from '../../../../common/side-panel/analytics/types';
import useAnalyticsForSidePanel from '../../../../common/side-panel/analytics/useAnalyticsForSidePanel';
import type { AnnotationInfoT } from '../../annotations/types';
import { SIDE_PANEL_ACTIONS } from '../../const';
import { useAnnotations } from '../../hooks/use-annotations';
import { useDispatch } from '../../hooks/use-dispatch';
type PropsT = {
  annotation: AnnotationInfoT;
};
export function useEditHandler({
  annotation
}: PropsT) {
  const dispatch = useDispatch();
  const {
    sendEventForAnnotationSelection
  } = useAnalyticsForSidePanel();
  const annotations = useAnnotations();
  const handleEditAnnotation = () => {
    const fullAnnotation = annotations.find(ann => ann.id === annotation.id);
    dispatch({
      type: SIDE_PANEL_ACTIONS.EDIT_ANNOTATION_START,
      annotationId: annotation.id
    });
    const eventPayload: SelectAnnotationPayloadT = {
      objectType: SIDE_PANEL_ACTIONS.EDIT_ANNOTATION_START,
      label: fullAnnotation?.annotationLabel?.title ?? '',
      objectId: annotation.id,
      actionBy: ACTION_BY.EDIT
    };
    sendEventForAnnotationSelection(eventPayload);
  };
  return {
    handleEditAnnotation
  };
}